export class DatePeriod{
    from: string; //date string yyyy/m/d
    to: string; //date string yyyy/m/d
}


// WEBPACK FOOTER //
// ./src/app/models/dates/datePeriod.ts